import React, {useEffect} from "react";
import {Table} from "antd";
import {formatNumberEuropean} from "../../../utils/numberUtil";


const EmployeeSalaryRecapitulation = ({salaryData}) => {

    const twoPointDecimal = (number) => Number(number).toFixed(2);

    return (<>
            <span onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation()
              }}>
                <Table
                    rowKey="employeeName"
                    bordered
                    size="small"
                    pagination={false}
                    columns={[{
                        title: "Ime i prezime djelatnika", dataIndex: ["employeeName"],
                    }, {
                        title: "Cijena radnog sata (prosjek)",
                        dataIndex: ["hourlyPrice"],
                        render: (value => (<>{formatNumberEuropean(value)} €</>))
                    }, {
                        title: "Utrošeni sati",
                        dataIndex: ["numberOfHours"],
                        render: (value => (<>{twoPointDecimal(value)} h</>))
                    }, {
                        title: "Ukupno", dataIndex: ["totalPrice"], render: (value => (<>{formatNumberEuropean(value)} €</>))
                    },]}
                    dataSource={salaryData}
                    scroll={{x: 700}}
                    summary={() => (<Table.Summary>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={3}>
                                <b>SUMA</b>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={0} colSpan={3}>
                                {formatNumberEuropean(salaryData[0]?.totalMonthly ? salaryData[0].totalMonthly: 0) + ' €'}
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>)}
                ></Table>
              </span>
        </>
    );
}

export default EmployeeSalaryRecapitulation;